import { render, staticRenderFns } from "./PackageLimitUsed.vue?vue&type=template&id=5a064ddb&scoped=true"
import script from "./PackageLimitUsed.vue?vue&type=script&lang=js"
export * from "./PackageLimitUsed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a064ddb",
  null
  
)

export default component.exports